import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const StorageConditionsSelect = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { value: '1', text: 'Do not store above 25°C ' },
        { value: '2', text: 'Do not store above 30°C' },
        { value: '3', text: 'Store below 25°C ' },
        { value: '4', text: 'Store below 25°C Don\'t  Freez, Protect From Light' },
        { value: '5', text: 'Store below 30°C ' },
        { value: '6', text: 'Store below 30°C Don\'t Freez' },
        { value: '7', text: 'Store between (4°C – 30°C) ' },
        { value: '8', text: 'Store in a freezer' },
        { value: '9', text: 'Store in a freezer (≤ -10°C)' },
        { value: '10', text: 'Store in a refrigerator (2°C – 8°C) ' },
        { value: '11', text: '	Store in a refrigerator (2°C – 8°C), Protect from light and heat' },
        { value: '12', text: 'Store below 30°C, Store in the original package, in order to protect from light.' },
        { value: '15', text: 'Store and transport frozen ' },
        { value: '17', text: 'Store below 25°C , Do not freeze ' },
        { value: '18', text: 'Store below 25°C , Store in the original package , Keep the container tightly closed in order to protect from moisture ' },
        { value: '21', text: 'Store below 30°C ,   protect from Light' },
        { value: '23', text: 'Store below 30°C , Protect from light and moisture ' },
        { value: '24', text: 'Store below 30°C, best use within one month of opening ' },
        { value: '25', text: 'Store below 30°C, Don\'t Refrigerator or Freez ' },
        { value: '26', text: 'Store below 30°C, in a dry place' },
        { value: '27', text: 'Store below 30°C. After opening use within one month. ' },
        { value: '28', text: 'Store between (2°C – 25°C)' },
        { value: '30', text: 'Store between (5°C – 25°C) ' },
        { value: '31', text: 'Store between +4°C - +30°C , Do not refrigerate or freeze' },
        { value: '32', text: 'Store from 2-8°C ' },
        { value: '36', text: 'Store in a refrigerator (2°C – 8°C) , Do not freeze ' },
        { value: '37', text: 'Store in a refrigerator (2°C – 8°C) , Do not freeze , In order to protect from light Store in the original container ' },
        { value: '38', text: 'Store in a refrigerator (2°C – 8°C) , protect from Light , don\'t freeze ' },
        { value: '39', text: 'Store in a refrigerator (2°C – 8°C) in order to protect from light store in the original container ' },
        { value: '41', text: 'Store in a refrigerator (5°C – 25°C) , protect from Light ' },
        { value: '42', text: 'Store between (15°C - 25°C) ' }
      ] }
    />
  );
};
export default StorageConditionsSelect;
